import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoMas: CultureInfo = {
  name: 'mas',
  displayName: 'Maa',
  iso3LanguageCode: 'mas',
  iso2LanguageCode: 'mas',
  ietfLanguageTag: 'mas',
  parent: null
};
